/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MachineSettingsDto {
  activeLicense?: string;
  can1?: string;
  can2?: string;
  driverScanDisabled?: boolean;
  fixedDriver?: number;
  fixedImplement?: number;
  gpsOnly?: boolean;
  implementScanDisabled?: boolean;
  ioBoxActive?: boolean;
  machineId?: number;
  speedSourceOverride?: string;
  tcActive?: boolean;
  tcCompatModeActive?: boolean;
  terminalType?: string;
}
